export default "__VITE_ASSET__B78UYTT7__"